import React, { Component } from 'react';
import {
    Card, CardBody, Container,
    Row, Col, CardGroup,
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '../../Services/history';
import AuthActions from '../../Redux/AuthRedux';
import LoginComponent from '../../Components/Login/LoginComponent';

const imgRoute = '/assets/background-login.jpeg';

class LoginContainer extends Component {
    componentWillMount = () => {
        const accessToken = JSON.parse(localStorage.getItem('access_token'));
        if (accessToken !== null) {
            history.push({ pathname: '/dashboard'});
        }
    }
    componentDidUpdate = (prevProps) => {
        if (!prevProps.auth.authSuccess && this.props.auth.authSuccess) {
            history.push({ pathname: '/dashboard'});
        }
    }
    loginUser = (email, password) => {
        this.props.actions.auth.login(email, password);
    }
    renderAlert = () => {
        if (this.props.auth.error && this.props.auth.error.getFields()) {
            return <div className="container my-3 text-danger">
                <i className="fa fa-warning mx-1"></i>{this.props.auth.error.message}
            </div>
        } else {
            return null
        }
    }
    render() {
        return (
            <div>
                <div className="app flex-row align-items-center">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md="8">
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            <LoginComponent
                                                onLogin={this.loginUser}
                                                error={this.props.auth.error}
                                                authSuccess={this.props.auth.authSuccess}
                                                error={this.props.auth.error} />
                                        </CardBody>
                                        {this.renderAlert()}
                                    </Card>
                                </CardGroup>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    actions: {
        auth: bindActionCreators(AuthActions, dispatch),
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);


// WEBPACK FOOTER //
// ./src/Containers/Login/LoginContainer.js